<template>
  <span class="icon" @click="$emit('click')" :key="Math.random()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :class="[{ 'icon-animation-pulse': !exists }, classes, 'bytesize']"
      :data-name="icon"
      viewBox="0 0 32 32"
      :style="{
        height: `${size}em`,
        width: `${size}em`,
      }"
      fill="none"
      stroke="currentcolor"
      :stroke-linecap="cap"
      :stroke-linejoin="join"
      :stroke-width="width"
      aria-hidden="true"
      role="img"
      v-html="content"
    ></svg>
  </span>
</template>

<script>
import * as icons from '@/mixins/icons'
import * as computed from '@/mixins/computed'
import { alert } from '@/utils/icons/bytesize'

export default {

  inheritAttrs: false,

  mixins: [
    icons.shared,
    icons.bytesize,
    computed.usesIconLibraries
  ],

  data: () => ({
    useLibrary: 'bytesize',
    fallback: alert
  }),

}
</script>
